<div class="pb-4 max-w-full flex flex-wrap gap-2" *ngIf="filters.length > 0">
  <small class="text-darkGray"> Filtros Aplicados: </small>

  <span *ngFor="let filter of filters; let i = index"
        class="mr-2 flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-lightBlue text-primary max-w-[300px]">
    
    <span class="whitespace-nowrap flex-1 p-1 truncate">
      <ng-container [ngSwitch]="filter.parsed">
        <span *ngSwitchCase="undefined"> {{ displayNames[filter.column] }}: {{ filter.value }} </span>
        <span *ngSwitchCase="'date'">{{ displayNames[filter.column] }}: {{ filter.value | date:'dd/MM/yyyy' }}</span>
        <span *ngSwitchCase="'date-arr'">
          {{ displayNames[filter.column] }}: 
          <span *ngFor="let date of filter.value; let last = last">
            {{ date | date:filter.format ?? 'dd/MM/yyyy' }} <ng-container *ngIf="!last"> al </ng-container>
          </span>
        </span>
        <span (click)="toggleFilterPopup($event, filter, op)" class="flex-1 p-1 gap-2" *ngSwitchCase="'relationship-arr'">
          {{ displayNames[filter.column] }}:
          <span class="text-center w-fit" *ngFor="let data of filter.value; let last = last">
            <span class="p-1 rounded-md bg-[#EDEEF0] text-darkGray">{{ getName(data, filter.relation_column ?? 'name') }}</span>
          </span>
        </span>
        <span class="flex gap-1" *ngSwitchCase="'array'">
          {{ displayNames[filter.column] }}:
          <span *ngFor="let data of filter.value; let last = last">
            <span class="p-1 rounded-md bg-[#EDEEF0] text-darkGray">{{ getName(data, filter.relation_column ?? 'name') }}<ng-container *ngIf="!last">,</ng-container></span>
          </span>
        </span>
      </ng-container>
    </span>

    <button (click)="onRemoveFilter.emit({pos: i, filter})"
            type="button"
            class="flex-shrink-0 ml-2 p-0.5 rounded-full inline-flex items-center justify-center text-primary hover:bg-primary hover:text-lightBlue focus:outline-none focus:bg-indigo-500 focus:text-white">
      <span class="sr-only">Remover opción de filtro</span>
      <svg class="w-3" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path d="M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z"></path>
      </svg>
    </button>
  </span>

  <button (click)="onClearFilters.emit()" class="focus:outline-none active:outline-none">
    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-lightGray2 text-darkGray hover:bg-darkGray hover:text.lightGray2">
      Borrar
    </span>
  </button>
</div>

<!-- Div flotante fuera del contenedor padre -->
<p-overlayPanel #op>
  <ng-container *ngIf="activeFilter">
    <div class="max-w-[900px] flex-1 p-1">
      <div class="mb-2">
        {{ displayNames[activeFilter.column] }}:
      </div>
      <div class="flex flex-wrap gap-2">
        <span *ngFor="let data of activeFilter.value; let last = last">
          <span class="p-1 rounded-md bg-[#EDEEF0] text-darkGray">
            {{ getName(data, activeFilter.relation_column ?? 'name') }}
          </span>
        </span>
      </div>
    </div>
  </ng-container>
</p-overlayPanel>
